import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { Loader } from '../../../components/loader';
import moment from'moment';
import { fetchAdministereds } from '../../../actions/administered';
import { addMedication } from '../../../actions/medicalRecords';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { forceInputUppercase } from "../../../utils/helper";
// import { createAdministered } from '../../actions/administered';

const $ = window.$;
const initialState = {
    date: moment().toDate(),
    administeredList: [],
    administeredId: '',
    more_info: '',
    loading: false,
    dewormings:[],
    vaccinations:[]
}

class AddMedication extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }
    submit(e){
        e.preventDefault();
        this.setState({ loading: true });
        let data = {
            PetShopId: this.props.petShop.currentPetshop.id,
            MedicalRecordId: this.props.mrId,
            date: moment(this.state.date).format('YYYY-MM-DD'),
            more_info: this.state.more_info,
            MedicationId: this.state.administeredId
        }
        let valid1 = moment(data.date).isValid();
        let valid2 = data.MedicationId !== 'N/A';

        if (valid1 && valid2) {
            this.props.addMedication(data);

        } else {
            NotificationManager.warning('Medication data incomplete.');
            this.setState({ loading: false });
        }
    }

    closeModal = () => {
        $('#add_medication').modal('hide');
        // this.resetState();
    }
    componentDidMount = () => {
        this.props.fetchAdministereds();
    }

    componentWillReceiveProps= (nextProps) => {
        if(this.props.newMedication !== nextProps.newMedication) {
            this.setState(initialState);
            this.props.fetchAdministereds();
            NotificationManager.success("Vaccination Added Successfully")
            $('#add_medication').modal('hide');
        }
        if(this.props.administeredList !== nextProps.administeredList) {
            let VaccinationOptions = [{label:'Select an option',value:'N/A'}];
            let DewormingOptions = [{label:'Select an option',value:'N/A'}];
            
            nextProps.administeredList.map(p => {
                if(p.type==='vaccine'){
                    VaccinationOptions.push({label: p.name, value: p.id});
                }
                if(p.type==='deworm'){
                    DewormingOptions.push({label: p.name, value: p.id});
                }
            });
            
            this.setState({vaccinations: VaccinationOptions, dewormings:DewormingOptions});
            // let options = [];
            // nextProps.administeredList.map(p => {
            //   options.push({label: p.name, value: p.id});
            // });
            // this.setState({administeredList: options});
            if(nextProps.administeredList.length > 0) {
                this.setState({administeredId: 'N/A'});
            }            
        }
    }

    changeDate = (value) => {
        this.setState({ date: value })
    }

    changeAdministered = (selected) => {
        if(selected) {
          this.setState({administeredId: selected.value});
        }
    }
    
    changeVal = (event) => {
        forceInputUppercase(event);
        this.setState({[event.target.name]: event.target.value})
    }

    render() {
        const {date, administeredId, more_info, vaccinations,dewormings,administeredList} = this.state; 
        const meditype= this.props.mediType;
        return (
            <div className="modal fade show" id="add_medication" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">                   
                        <form className="m-form">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">New {meditype==='vaccine'?'Vaccination':meditype==='deworm'?'Treatment':null}</h5>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="m-form__section m-form__section--first">
                                            <div className="form-group m-form__group row">
                                                <label className="col-xl-3 col-lg-3 col-form-label">Date Administered:</label>
                                                <div className="col-xl-9 col-lg-9">
                                                    <DatePicker selected={date} value={date} onChange={ this.changeDate } onSelect={ this.changeDate }/>
                                                    <span className="m-form__help">Please enter date of administered</span>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label className="col-xl-3 col-lg-3 col-form-label">Vaccination Name:</label>
                                                <div className="col-xl-9 col-lg-9">
                                                    <Select options={meditype==='vaccine'?vaccinations :meditype==='deworm'? dewormings : null} value={ administeredId } name="administeredId" onChange={ this.changeAdministered } placeholder="Select the administered type" />
                                                    <span className="m-form__help">Please select vaccination</span>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label className="col-xl-3 col-lg-3 col-form-label">Notes (Serial, Expiration, Etc.):</label>
                                                <div className="col-xl-9 col-lg-9">
                                                    <input type="text" value={more_info} name="more_info" onChange={ this.changeVal } className="form-control m-input" />
                                                    <span className="m-form__help">Enter more information</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            {this.state.loading == false ?
                                <div>
                                    <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeModal}>Close</button>
                                    <button onClick={(e) => this.submit(e)} type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                                </div>
                                :
                                <div className="center-row">
                                    <Loader size={50} />
                                </div>
                            }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    petShop: state.petShopReducer,
    administeredList: state.administeredTypeReducer.administeredList,
    newMedication: state.medicalRecordsReducer.newMedication,
});

const mapDispatchToProps = dispatch => ({
    fetchAdministereds: () => {
        dispatch(fetchAdministereds());
    },
    addMedication: (v) => {
        dispatch(addMedication(v));
    }
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddMedication));
